export const withBoutiqueAssociation = (payload = {}, boutiqueId = null) => ({
  ...payload,
  pageMode: "store",
  pageModeConfig: {
    ...(payload.pageModeConfig || {}),
    mode: "store",
    settings: {
      ...(payload.pageModeConfig?.settings || {}),
      ...(boutiqueId ? { boutiqueId: String(boutiqueId) } : {}),
    },
  },
});
